import { useEffect, useState } from "react";
import { api } from '@/utils/http';  

export function useStepGate(statusUrl) {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const resp = await api.get(statusUrl);
       
        const data = resp.data || {};
      
        // Se o backend sinalizou que já está autenticado, redireciona
        if (data.redirect) {
          window.location.assign(data.redirect);
          return;
        }

        if (!cancelled) setAllowed(Boolean(data.ok));
      } catch (e) {
        window.location.assign("/");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [statusUrl]);

  return { loading, allowed };
}
